var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { Col, Icon, Row, Surface, TextBody, TextTitle, } from '../../atoms';
import { API } from '@xbto/api-client';
import { theme } from '@xbto/design-system';
import { DEFAULTS, formatters } from 'common';
import { Hypertext } from '../../molecules';
const titleTrading = 'Trading & Cash';
const titleCustody = 'Custody';
const titleFund = 'Funds';
const accountTypeTitles = {
    Interest: titleTrading,
    Trading: titleTrading,
    ProTrading: titleTrading,
    Pool: titleTrading,
    Custody: titleCustody,
    Vault: titleCustody,
    Fund: titleFund,
};
const descriptionTrading = 'We support digital assets such as tokens, yield-bearing stablecoins and tokenized real-world assets.';
const descriptionCustody = 'Secure your digital assets with superior protection, bankrupcy-remote custody and white-glove support.';
const descriptionFund = 'Increase you holdings and preserve your wealth – capture alpha with our actively managed funds.';
const accountTypeDescriptions = {
    Interest: descriptionTrading,
    Trading: descriptionTrading,
    ProTrading: descriptionTrading,
    Pool: descriptionTrading,
    Custody: descriptionCustody,
    Vault: descriptionCustody,
    Fund: descriptionFund,
};
export const AccountTypeCard = memo((_a) => {
    var { count, type, value, onPressEmpty, small = false } = _a, rest = __rest(_a, ["count", "type", "value", "onPressEmpty", "small"]);
    // Vars
    const isEmpty = count === 0;
    const isPressable = !isEmpty && !!rest.onPress;
    const description = accountTypeDescriptions[type];
    // Handlers
    const handlePressEmpty = useCallback(() => {
        if (type === API.AccountType.Fund) {
            onPressEmpty(API.AccountType.Fund);
            return;
        }
        if (type === API.AccountType.Vault || type === API.AccountType.Custody) {
            onPressEmpty(API.AccountType.Custody);
            return;
        }
        onPressEmpty(API.AccountType.ProTrading);
    }, [onPressEmpty, type]);
    // Render
    const countText = count > 1
        ? `${count} ${type === API.AccountType.Fund ? 'funds' : 'accounts'}`
        : ' '; // TODO: @benoit if you want to address this later - https://github.com/stablehouse-dev/stablehouse-front-end-apps/pull/1360#discussion_r2110034852
    const content = isEmpty ? description : countText;
    return (_jsxs(Surface, Object.assign({}, rest, { disabled: isEmpty, variant: isEmpty ? 'tertiary' : 'primary', style: [$.container, small ? $.containerSmall : null], children: [_jsxs(Row.LRT, { children: [_jsxs(Col, { style: { flex: 1 }, children: [_jsx(TextBody, { em: true, color: isEmpty ? 'primary' : 'inverse', lhFull: true, children: accountTypeTitles[type] }), _jsx(TextBody, { mt: "2", small: true, color: isEmpty ? 'secondary' : 'tertiary', children: content })] }), isPressable && (_jsx(Col.C, { style: $.button, children: _jsx(Icon, { name: "ArrowForward", color: "inverse", size: "sm" }) }))] }), !isEmpty && !!value && (_jsx(TextTitle, { color: isEmpty ? 'primary' : 'inverse', children: formatters.getBaseCurrency(value, {
                    decimals: DEFAULTS.DECIMAL_SCALE,
                }) })), isEmpty && (_jsx(Row, { children: _jsx(Hypertext, { color: "primary", onPress: handlePressEmpty, children: "Learn more" }) }))] })));
});
const $ = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'stretch',
        padding: theme.spacing[4],
        minHeight: 148,
    },
    containerSmall: {
        minHeight: 112,
    },
    // TODO(Benoit): use <Button icon="ArrowForward" /> ?
    button: {
        borderRadius: theme.radius.sm,
        backgroundColor: 'rgba(255, 255, 255, 0.20)', // TODO(Benoit): Design must tokenize this color
        width: 24,
        height: 24,
    },
});
